import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=2452531e&scoped=true&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"
import style0 from "./Properties.vue?vue&type=style&index=0&id=2452531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452531e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VDialog,VProgressCircular})
